/**
 * Central game and platform configuration for Style Sprint.
 */
export const CONFIG = {
  GAME_SLUG: 'style-sprint',
  
  // Lane & runner mechanics
  LANES: {
    COUNT: 3,
    SPACING: 2.4,
    COORDS: [-2.4, 0, 2.4],
    CHANGE_SPEED: 14.0, // Lerp smoothing factor
  },

  RUNNER: {
    FIXED_Z: 0.0,
    JUMP_IMPULSE: 9.5,
    GRAVITY: -26.0,
    COLLISION_RADIUS: 0.45,
    COLLISION_HEIGHT: 1.6,
  },

  WORLD: {
    INITIAL_SPEED: 14.0,
    MAX_SPEED: 28.0,
    ACCELERATION: 0.08, // Speed increase per second
    TRACK_WIDTH: 8.4,
    TRACK_SEGMENT_LENGTH: 50.0,
    TRACK_SEGMENT_COUNT: 6,
    SPAWN_Z: -100.0,
    RECYCLE_Z: 50.0,
    MIN_SPAWN_INTERVAL: 1.0,
    MAX_SPAWN_INTERVAL: 2.2,
  },

  SCORING: {
    DISTANCE_PER_POINT: 10.0, // 1 point per 10 distance units
    ORB_VALUE: 1,
  },

  PLATFORM: {
    CONNECT_ORIGIN: 'https://start.ng',
    CONNECT_URL: 'https://start.ng/connect',
    REQUEST_TIMEOUT_MS: 5000,
    LEADERBOARD_LIMIT: 10,
  },

  GRAPHICS: {
    FOV: 60,
    NEAR: 0.1,
    FAR: 200,
    CAMERA_OFFSET: { x: 0, y: 3.6, z: 5.6 },
    CAMERA_LOOKAT: { x: 0, y: 1.0, z: -10.0 },
    MAX_DPR: 2.0,
  },
};
